import { Swiper } from 'swiper';
import { Autoplay, Pagination, Navigation, Keyboard } from 'swiper/modules';

const addonImagesElements = document.querySelectorAll( '.wp-block-qala-blocks-logo-slider' );

/**
 * Converts a given string into an object, decoding it if it's an encoded JSON string.
 * This saves us from breaking this script if there is no dataset, or the dataset is invalid.
 *
 * @param {string} stringData String to be parsed.
 *
 * @return {Object} Empty object or decoded data object.
 */
const returnObjectIfDataValid = stringData => {
	try {
		const parsedString = JSON.parse( stringData );

		if ( parsedString && typeof parsedString === 'object' ) {
			return parsedString;
		}
	} catch ( e ) {}

	return {};
};

addonImagesElements.forEach( sliderInstance => {
	const imageSlider = sliderInstance.querySelector( '.logo-slider' );
	const oldSlider = imageSlider.classList.contains( 'old' );
	const sliderData = returnObjectIfDataValid( imageSlider.dataset.swiperControls ?? '' );
	const sliderInstanceWrapper = sliderInstance.querySelector( '.swiper-wrapper' );
	const sliderKeyboardEnabled = sliderInstanceWrapper.getAttribute( 'data-keyboard' ) === 'true';

	if ( oldSlider ) {
		imageSlider.querySelector( '.wp-block-gallery' ).classList.add( 'swiper-wrapper' );

		imageSlider.querySelectorAll( '.wp-block-image' ).forEach( image => {
			image.classList.add( 'swiper-slide' );
		} );
	}

	let sliderConfig = {
		modules: [ Autoplay, Navigation, Pagination, Keyboard ],
		slidesPerView: 'auto',
		// True by default. Allow overwrite by our setting.
		loop: Object.hasOwn( sliderData, 'loopItems' ) ? sliderData.loopItems : true,
		navigation: ( Object.hasOwn( sliderData, 'showNavigation' ) && sliderData.showNavigation === true ) ? { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' } : { enabled: false },
		pagination: ( Object.hasOwn( sliderData, 'showPagination' ) && sliderData.showPagination === true ) ? { el: '.swiper-pagination', clickable: true } : { el: null },
		keyboard: {
			enabled: sliderKeyboardEnabled ? true : false,
		},
	};

	// If we have autoplay on we want to tweak the config.
	if (
		imageSlider.classList.contains( 'has-auto-carousel' ) ||
		( Object.hasOwn( sliderData, 'autoPlay' ) && sliderData.autoPlay === true )
	) {
		sliderConfig = {
			...sliderConfig,
			centeredSlides: true,
			watchSlidesProgress: true,
			autoplay: {
				delay: 1,
				pauseOnMouseEnter: false,
				disableOnInteraction: false,
			},
			speed: Object.hasOwn( sliderData, 'autoPlaySpeed' ) ? parseInt( sliderData.autoPlaySpeed ) : 4000,
			allowTouchMove: false,
		};
	}

	// If we have autoplay on we want to tweak the config.
	if ( imageSlider.classList.contains( 'has-reverse-direction' ) ||
		( Object.hasOwn( sliderData, 'reverseDirection' ) && sliderData.reverseDirection === true )
	) {
		sliderConfig = {
			...sliderConfig,
			autoplay: {
				delay: 1,
				pauseOnMouseEnter: false,
				disableOnInteraction: false,
				reverseDirection: true,
			},
		};
	}

	const swiperInstance = new Swiper( imageSlider, sliderConfig );

	// The arrows are rendered disabled so they are never a focus stop before the
	// slider is running. Once Swiper owns them, hand them over.
	swiperInstance.on( 'init', () => {
		imageSlider.querySelectorAll( '.swiper-button-prev, .swiper-button-next' ).forEach( button => {
			button.removeAttribute( 'disabled' );
			button.removeAttribute( 'aria-disabled' );
			button.classList.remove( 'swiper-button-disabled' );
		} );
	} );
} );
